export default function ProcessRecoveryDirective() {
  return {
    template: require('./process-recovery.html'),
    scope: {
      process: '=',
      isEditable: '=',
    },
    controller: 'ProcessRecoveryController',
    controllerAs: 'processRecoveryVM',
    bindToController: true,
    replace: true
  };
}
